// import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { IonContent, IonRouterLink } from "@ionic/react";
import React, { Component } from "react";
import logo from "../images/logoDark.png";

class ClaudeCode extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount = () => {
    document.title = "Claude Code Tutor";
  };

  openingParagraph = (
    <div>
      <span>
        I teach teens and adults how to build real software with{" "}
        <strong>Claude Code</strong>. The approach is rooted in the idea that,
        as one{" "}
        <a href="https://www.nytimes.com/2026/03/12/magazine/ai-coding-programming-jobs-claude-chatgpt.html">
          recent article
        </a>{" "}
        put it,{" "}
        <em>
          "a coder is now more like an architect than a construction worker."
        </em>
      </span>
      <div style={{ height: "10px" }} />
      <span>
        Students begin with a short overview of modern app architecture, then
        start building passion projects of their own choosing. They can work
        solo, in pairs, or as a group. Throughout, my job is to keep their
        learning focused on app organization, architecture, and structure,
        while Claude handles almost all of the grunt work. Claude is also used
        to brainstorm and explain architectural pathways, UI decisions, and
        other big-picture ideas.
      </span>
      <div style={{ height: "10px" }} />
      <span>
        <a href="https://www.thepaperoption.org/">ThePaperOption.org</a>,{" "}
        <a href="https://www.medialab.org/">MediaLab.org</a>, and{" "}
        <a href="https://www.mathartprojects.com/">MathArtProjects.com</a> are
        three apps I built using this workflow.
      </span>
    </div>
  );

  curriculumIntro = (
    <div>
      <span>
        These are the architectural concepts students learn first, and keep
        returning to as their projects grow:
      </span>
    </div>
  );

  curriculumList = (
    <div>
      <ul>
        <li>
          <strong>C.R.U.D.</strong> &ndash; All software (even games) performs
          four primary operations: Create, Read, Update, and Delete.
        </li>
        <li>
          <strong>Local vs. remote</strong> &ndash; For each of those four
          operations, a designer must decide whether it happens locally on the
          device or in a remote location such as a server or database.
        </li>
        <li>
          <strong>Version control</strong> &ndash; GitHub is essential to app
          design. It lets developers go back in time if something isn't
          working, and experiment by branching off in different directions.
        </li>
        <li>
          <strong>APIs</strong> &ndash; Apps often need to interact with other
          apps through what is called an Application Programming Interface.
        </li>
        <li>
          <strong>Authentication & security</strong> &ndash; Most apps must
          give careful thought to usernames, passwords, accounts, and security
          more broadly.
        </li>
      </ul>
    </div>
  );

  firstClassIntro = (
    <div>
      <span>
        Before the first class, I ask students what kinds of projects they'd
        like to build, so I can research the right architectures in advance.
        By the end of that first session, each student is already on their
        way to creating a robust piece of software.
      </span>
    </div>
  );

  contact = (
    <div>
      To learn more about my tutoring services, or to schedule a lesson, please
      send an email to{" "}
      <a href="mailto:zach@codingtutor.nyc">zach@codingtutor.nyc</a>.<br />
    </div>
  );

  render() {
    let header: any;
    let main: any;

    ///////////////// MOBILE RENDER /////////////////
    if (this.props.appState.size == "mobile") {
      header = (
        <header className="cell headerMobile">
          <h1 style={{ fontSize: "38pt" }}>Claude Code</h1>
          <h2 style={{ fontSize: "16pt", paddingTop: "5px" }}>
            <IonRouterLink href="/">NYC Coding & Tech Tutor</IonRouterLink>
          </h2>
        </header>
      );

      main = (
        <main className="cell mainMobile">
          {this.openingParagraph}

          <div className="subHeadingMobileScratch">What Students Learn</div>
          {this.curriculumIntro}
          {this.curriculumList}
          {this.firstClassIntro}

          <div className="subHeadingMobileScratch">Contact</div>
          {this.contact}

          <div
            style={{
              textAlign: "center",
              marginTop: "28px",
              marginBottom: "14px",
            }}
          >
            <IonRouterLink href="/" style={{ textDecoration: "none" }}>
              <img style={{ width: "110px" }} src={logo} />
              <br />
              <span
                style={{
                  fontSize: "12pt",
                  letterSpacing: "1.4px",
                  textDecoration: "none",
                }}
              >
                &copy; CodingTutor.nyc
              </span>
            </IonRouterLink>
          </div>
        </main>
      );
    }

    ///////////////// DESKTOP RENDER /////////////////
    if (this.props.appState.size == "desktop") {
      header = (
        <header className="cell headerDesktop">
          <h1 style={{ fontSize: "56pt" }}>Claude Code</h1>
          <h2 style={{ fontSize: "22pt" }}>
            <IonRouterLink href="/">NYC Coding & Tech Tutor</IonRouterLink>
          </h2>
        </header>
      );

      main = (
        <main className="cell mainDesktop">
          {this.openingParagraph}

          <div className="subHeadingDesktopScratch">What Students Learn</div>
          {this.curriculumIntro}
          {this.curriculumList}
          {this.firstClassIntro}

          <div className="subHeadingDesktopScratch">Contact</div>
          {this.contact}

          <div
            style={{
              textAlign: "center",
              marginTop: "28px",
              marginBottom: "14px",
            }}
          >
            <IonRouterLink href="/" style={{ textDecoration: "none" }}>
              <img style={{ width: "120px" }} src={logo} />
              <br />
              <span
                style={{
                  fontSize: "12pt",
                  letterSpacing: "1.4px",
                  textDecoration: "none",
                }}
              >
                &copy; CodingTutor.nyc
              </span>
            </IonRouterLink>
          </div>
        </main>
      );
    }

    return (
      <IonContent color="secondary">
        <section>
          {header}
          {main}
        </section>
      </IonContent>
    );
  }
}

export default ClaudeCode;
